import React from 'react';
import { WARMUPS_SONG_ID } from '../../../../services/songNotesModel';
import LessonWarmups from '../warmups/LessonWarmups';
import './RightColumn.css';

/**
 * Right column (desktop, >=1200px; and 1024-1199 on the Warm-ups tab). Since
 * pass 3 (2026-09-28) it carries ONE of two things: on a song tab the Song
 * panel (Lyrics · Tracks · Videos, built by the page and handed in as
 * `songPanel`), on Warm-ups the routine. It used to BE the lyrics column,
 * with the videos dock beneath; that markup now lives in songpanel/, where
 * the same panes also open as a sheet below 1200.
 *
 * THE DRAWER IS NOT MOUNTED HERE, AND SINCE BATCH B NOT OPENED FROM HERE
 * EITHER. This column used to own a RecapDrawer behind local state (two
 * instances, two editors per tier if both ever opened); 2026-09-13 moved the
 * one drawer to the page and left this column a disclosure row that asked for
 * it. Design pass 2 change 7 (2026-09-21) removed that row too: the topbar
 * Recap button is filled and labelled on every tab at every width, and the
 * Last lesson row in the rail opens the same drawer at its history, so a
 * third route that existed only on a song tab at desktop was one more thing
 * to read for no new reach. This column is the Song panel, and on Warm-ups
 * the routine; recapEntryPoints.test.js pins that it no longer
 * takes an onOpenRecap.
 */
const RightColumn = ({ song, warmups = null, deckInStrip = false, songPanel = null }) => {
	const isWarmups = song?.id === WARMUPS_SONG_ID;

	// PASS 3 D1 (2026-09-28): on a song tab this column IS the Song panel
	// (Lyrics · Tracks · Videos), built by the page so the same panes open as
	// a sheet below 1200 (songpanel/SongPanel.js). The lyrics and videos
	// markup that lived here moved verbatim to songpanel/LyricsPane.js and
	// songpanel/VideosPane.js. Warm-ups keeps the routine, unchanged.
	if (!isWarmups) {
		return <aside className="ld-rightcol ld-rightcol--song">{songPanel}</aside>;
	}

	return (
		<aside className="ld-rightcol ld-rightcol--warmups">
			{warmups && warmups.mount === 'right' ? (
				// The Warm-ups tab's desktop home for the player (plan branch 2):
				// this column exists only at >=1200px (and 1024-1199 on Warm-ups),
				// so the page mounts here when `warmups.mount === 'right'` and
				// above the notes otherwise. I1: when the conducting strip is up
				// the deck lives THERE, so this column renders the routine alone;
				// otherwise the transport would exist twice over one engine.
				<LessonWarmups warmups={warmups} region={deckInStrip ? 'routine' : 'full'} />
			) : (
				<p className="ld-rightcol__status">Warm-ups has no lyrics — pick a song to see them here.</p>
			)}
		</aside>
	);
};

export default RightColumn;
